import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tags" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.tooLongTagClass)
    }, " #too-long ", 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.stateTagClass)
    }, _toDisplayString(_ctx.tagText), 3)
  ]))
}